import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "../Reveal";
import { SERVICES } from "../../lib/data";

const ServicesGrid = ({ showCta = true }) => (
  <section data-testid="services-section" className="border-t border-black/10 bg-ink-surface">
    <div className="mx-auto max-w-7xl px-5 py-20 lg:px-8 lg:py-32">
      <Reveal>
        <Eyebrow>Services</Eyebrow>
        <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <h2 className="max-w-xl font-display text-3xl font-extrabold leading-tight tracking-tight sm:text-4xl lg:text-5xl">
            One contractor for the whole property.
          </h2>
          <p className="max-w-md text-sm leading-relaxed text-mist md:text-base">
            From forecourt concrete to car-wash equipment, Petroline Services covers the
            repair, renovation and maintenance needs of petroleum retail locations.
          </p>
        </div>
      </Reveal>

      <div className="mt-14 grid gap-px border border-black/10 bg-black/10 sm:grid-cols-2 lg:grid-cols-4">
        {SERVICES.map((service, i) => (
          <Reveal key={service.title} delay={(i % 4) * 0.08} className="h-full">
            <div
              data-testid={`service-card-${service.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="group flex h-full flex-col bg-white p-8 transition-colors duration-300 hover:bg-ink"
            >
              <span className="font-display text-xs font-bold text-black/30">
                {String(i + 1).padStart(2, "0")}
              </span>
              <service.icon className="mt-6 h-7 w-7 text-ember transition-transform duration-300 group-hover:-translate-y-1" />
              <h3 className="mt-5 font-display text-lg font-bold tracking-tight text-coal">
                {service.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-mist">{service.description}</p>
            </div>
          </Reveal>
        ))}
      </div>

      {showCta && (
        <Reveal className="mt-14">
          <div className="flex flex-col items-start justify-between gap-6 border border-black/10 bg-white p-8 md:flex-row md:items-center lg:p-10">
            <h3 className="font-display text-xl font-bold tracking-tight md:text-2xl">
              Have a maintenance issue or upcoming project?
            </h3>
            <Link
              to="/contact"
              data-testid="services-cta-link"
              className="group inline-flex shrink-0 items-center gap-3 bg-ember px-7 py-3.5 font-display text-sm font-bold uppercase tracking-wider text-coal transition-transform duration-200 hover:-translate-y-0.5"
            >
              Talk to Petroline Services
              <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
            </Link>
          </div>
        </Reveal>
      )}
    </div>
  </section>
);

export default ServicesGrid;
